'use client';

import { Link } from 'lucide-react';
import { useToastStore } from '@/stores/useToastStore';
import IconAdaptive from '@/components/IconAdaptive';

const BUTTON_CLASS = {
    default:
        'flex shrink-0 justify-center items-center gap-1.5 w-9 h-9 px-0 md:w-auto md:px-4 rounded-full border border-color-input-border bg-color-white-base text-color-co-gray-dark font-notojp font-bold text-xs hover:border-color-service-selected hover:text-color-service-selected transition-colors duration-150',
    compact:
        "relative flex shrink-0 justify-center items-center gap-1 -mt-0.5 w-6 h-6 px-0 md:w-auto md:h-[22px] md:px-2.5 rounded-full border border-color-input-border bg-color-white-base text-color-co-gray-dark font-notojp font-bold text-xs hover:border-color-service-selected hover:text-color-service-selected transition-colors duration-150 after:absolute after:-inset-2 after:content-['']",
};

export interface HubNewsCopyUrlUnitProps {
    copyUrl: string;
    label?: string;
    toastMessage?: string;
    size?: keyof typeof BUTTON_CLASS;
}

export default function HubNewsCopyUrlUnit({
    copyUrl,
    label = 'URLをコピー',
    toastMessage = 'URLをコピーしました',
    size = 'default',
}: HubNewsCopyUrlUnitProps) {
    const showToastAsync = useToastStore((s) => s.showToastAsync);

    const handleCopyUrl = async () => {
        try {
            await navigator.clipboard.writeText(`${window.location.origin}${copyUrl}`);
            await showToastAsync(toastMessage, 'success');
        } catch {
            await showToastAsync('URLをコピーできませんでした', 'error');
        }
    };

    return (
        <button type="button" className={BUTTON_CLASS[size]} onClick={handleCopyUrl} aria-label={label}>
            <IconAdaptive
                Icon={Link}
                strokeWidth={2.2}
                baseSize={14}
                breakpoints={{ md: size === 'compact' ? 12 : 14 }}
            />
            <span className="hidden md:inline">{label}</span>
        </button>
    );
}
